import React, { useEffect } from 'react'
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import { Avatar, Button, Card, CircularProgress, FormControl, Grid, InputLabel, LinearProgress, MenuItem, Modal, Popover, Select, Typography, TextField, Checkbox } from '@mui/material'
import PeopleOutlineOutlinedIcon from '@mui/icons-material/PeopleOutlineOutlined';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import SearchIcon from '@mui/icons-material/Search';

import PlayArrowOutlinedIcon from '@mui/icons-material/PlayArrowOutlined';
import PauseOutlinedIcon from '@mui/icons-material/PauseOutlined';
import NoteAddOutlinedIcon from '@mui/icons-material/NoteAddOutlined';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import { Outlet } from 'react-router-dom';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Divider from '@mui/material/Divider';

import InstagramLogin from '../../InstagramLogin';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CampaignsNoResults from "../../../assets/campaignsNoResults.png";
import TrackingBar from './TrackingBar';
import StartTracking from './StartTracking';


function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

const StyledTabs = styled((props) => (
    <Tabs
        {...props}
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
))({
    '& .MuiTabs-indicator': {
        display: 'flex'
    },
    '& .MuiTabs-indicatorSpan': {
        width: '100%',
        backgroundColor: '#000',
    },
});

const StyledTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
        textTransform: 'none',
        fontWeight: theme.typography.fontWeightLight,
        fontSize: theme.typography.pxToRem(15),
        marginRight: theme.spacing(1),
        color: 'rgba(0, 0, 0, 0.4)',
        '&.Mui-selected': {
            color: 'rgba(0, 0, 0, 1)',
        },
        '&.Mui-focusVisible': {
        },
    }),
);

function TrackingHome(props) {

    const user = props.userData;
    const showDashboard = true;

    const [tabValue, setTabValue] = React.useState(0);

    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const activeTab = (tabValue == 0) ? "#F8C036" : "#F0F0F0";
    const pausedTab = (tabValue == 1) ? "#E4F87F" : "#F0F0F0";
    const draftsTab = (tabValue == 2) ? "#E4F87F" : "#F0F0F0";
    const archivedTab = (tabValue == 3) ? "#E4F87F" : "#F0F0F0";

    const [activeCampaigns, setActiveCampaigns] = useState([])
    const [tempActiveCampaigns, setTempActiveCampaigns] = useState([])
    const [pausedCampaigns, setPausedCampaigns] = useState([])
    const [tempPausedCampaigns, setTempPausedCampaigns] = useState([])
    const [draftCampaigns, setDraftCampaigns] = useState([])
    const [tempDraftCampaigns, setTempDraftCampaigns] = useState([])
    const [archivedCampaigns, setArchivedCampaigns] = useState([])
    const [tempArchivedCampaigns, setTempArchivedCampaigns] = useState([])

    function setTabLabel(label, icon) {
        return (<div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px" }}>
            {icon}
            <Typography>{label}</Typography>
        </div>)
    }
    const tabLabels = [setTabLabel("Active", <PlayArrowOutlinedIcon />), setTabLabel("Paused", <PauseOutlinedIcon />), setTabLabel("Drafts", <NoteAddOutlinedIcon />), setTabLabel("Archived", <Inventory2OutlinedIcon />)]
    const tabColors = [activeTab, pausedTab, draftsTab, archivedTab]
    const tabLengths = [activeCampaigns.length, pausedCampaigns.length, draftCampaigns.length, archivedCampaigns.length]

    const [isLoading, setIsLoading] = useState(true)

    function setCampaigns(allCampaigns) {
        for (const [key, value] of Object.entries(allCampaigns)) {
            if (key == 0) {
                setActiveCampaigns(value)
                setTempActiveCampaigns(value)
            } else if (key == 1) {
                setPausedCampaigns(value)
                setTempPausedCampaigns(value)
            } else if (key == 2) {
                setDraftCampaigns(value)
                setTempDraftCampaigns(value)
            } else if (key == 3) {
                setArchivedCampaigns(value)
                setTempArchivedCampaigns(value)
            }
        }
    }

    async function fetchAllCampaigns() {

        setIsLoading(true)
        const token2 = await user.getIdToken()

        let data = {
            showTrackingCampaigns: true
        }

        let campaignApiOptions = {
            method: 'POST',
            body: JSON.stringify(data),
            headers: new Headers({
                'Authorization': `Bearer ${token2}`,
                'Content-Type': "application/json"
            })
        }
        await fetch(process.env.REACT_APP_API_ADDRESS + '/api/fetch_all_campaigns', campaignApiOptions)
            .then(result => result.json())
            .then(body => { setCampaigns(body); setIsLoading(false) });
    }

    const [instaUsernames, setInstaUsernames] = useState([])
    const [isLoadingInstaButton, setIsLoadingInstaButton] = useState(false)

    async function fetchInstagramAccounts() {
        setIsLoadingInstaButton(true);
        const token2 = await user.getIdToken()

        let options = {
            method: 'GET',
            headers: new Headers({
                'Authorization': `Bearer ${token2}`,
                'Content-Type': "application/json"
            })
        }
        await fetch(process.env.REACT_APP_API_ADDRESS + '/api/fetch_brand_insta_usernames', options)
            .then(result => result.json())
            .then(body => { setInstaUsernames(body); setIsLoadingInstaButton(false) });
    }

    useEffect(() => {
        fetchAllCampaigns()
        fetchInstagramAccounts()
    }, [])



    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => { setOpen(false); setIsLoading(true); fetchAllCampaigns() }

    var displayCampaignsNoResults = (isLoading == false && activeCampaigns.length == 0) ? "block" : "none";

    const handleCloseDialog = () => {
        console.log("No access")
    };



    const [anchorEl, setAnchorEl] = useState(null);

    const handleClickInstaAccount = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleCloseInstaAccount = () => {
        setAnchorEl(null);
    };

    const openInstaAccount = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const [searchCampaign, setSearchCampaign] = useState("")

    const handleSearchCampaign = (event) => {
        const searchText = event.target.value.toLowerCase();
        setSearchCampaign(searchText);

        if (searchText === '') {
            // If the search input is empty, reset to the complete list
            setTempActiveCampaigns(activeCampaigns);
            setTempPausedCampaigns(pausedCampaigns);
            setTempDraftCampaigns(draftCampaigns);
            setTempArchivedCampaigns(archivedCampaigns);
        } else {
            if (tabValue == 0) {
                // Otherwise, filter based on the search input
                const filteredCampaigns = activeCampaigns.filter(item =>
                    item.campaignName.toLowerCase().includes(searchText)
                );
                setTempActiveCampaigns(filteredCampaigns);
            } else if (tabValue == 1) {
                // Otherwise, filter based on the search input
                const filteredCampaigns = pausedCampaigns.filter(item =>
                    item.campaignName.toLowerCase().includes(searchText)
                );
                setTempPausedCampaigns(filteredCampaigns);
            } else if (tabValue == 2) {

                // Otherwise, filter based on the search input
                const filteredCampaigns = draftCampaigns.filter(item =>
                    item.campaignName.toLowerCase().includes(searchText)
                );
                setTempDraftCampaigns(filteredCampaigns);

            } else if (tabValue == 3) {

                // Otherwise, filter based on the search input
                const filteredCampaigns = archivedCampaigns.filter(item =>
                    item.campaignName.toLowerCase().includes(searchText)
                );
                setTempArchivedCampaigns(filteredCampaigns);
            }
        }
    };


    const [isBliActive, setIsBliActive] = useState(false); // State for checkbox

    const handleBliCampaignFilter = () => {

        setIsBliActive(!isBliActive); // Toggle checkbox state

        // Update tempActiveCampaigns based on the checkbox value
        if (!isBliActive) {
            const filteredActiveCampaigns = activeCampaigns.filter(
                (campaign) => campaign.isBliActive === !isBliActive
            );
            setTempActiveCampaigns(filteredActiveCampaigns);
        } else {
            // When unchecked, reset to all active campaigns
            setTempActiveCampaigns(activeCampaigns);
        }

    };

    return (
        <div style={{ padding: "20px" }}>
            {!showDashboard && <Dialog
                open={true}
                onClose={handleCloseDialog}
                fullWidth={true}
                maxWidth='sm'
            >
                <Box style={{ display: "flex", justifyContent: "center", flexDirection: "column", alignItems: 'center' }}>
                    <DialogTitle>
                        {"Your free trial has ended."}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText >
                            Please contact us at shubham@closerapp.in to get your access.
                        </DialogContentText>
                    </DialogContent>
                </Box>
            </Dialog>}
            <Grid container style={{ justifyContent: "center", marginBottom: "20px", flexDirection: "column", alignItems: "center" }}>
                <Button style={{ width: "85%", height: "100px", borderRadius: "25px", boxShadow: "none", backgroundColor: "#F8C036", color: "black", fontWeight: 600, fontSize: "18px" }} onClick={handleOpen}>
                    + Start a Campaign
                </Button>
                <Modal
                    open={open}
                    onClose={handleClose}
                >
                    <Box>
                        <StartTracking handleClose={handleClose} userData={user} />
                    </Box>
                </Modal>
                {isLoading && <Box style={{ marginTop: "50px" }}><CircularProgress style={{ color: "black", }} size={100} /></Box>}
                {!isLoading &&
                    <Box sx={{ width: "80%" }}>
                        <Box sx={{ display: "flex" }}>
                            <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", marginTop: "25px", width: "70%" }}>
                                <StyledTabs value={tabValue} onChange={handleChange} >
                                    {tabLabels.map((value, index) => (
                                        <StyledTab key={index} icon={<div style={{ background: tabColors[index], color: "black", padding: "5px 10px 5px 10px", borderRadius: "5px" }}>{tabLengths[index]}</div>} iconPosition="end" label={value} />
                                    ))}
                                </StyledTabs>
                            </Box>

                            <Box sx={{ borderBottom: 1, borderColor: 'divider', display: "flex", marginTop: "25px", width: "30%", justifyContent: "right", alignItems: "center" }}>
                                {/* <InstagramLogin userData={user} /> */}
                                <Button endIcon={<ArrowDropDownIcon />} onClick={(e) => handleClickInstaAccount(e)} sx={{ color: "black", background: "#F8C036", padding: "15px" }}>
                                    Instagram Connections
                                </Button>
                                <Popover
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'right',
                                    }}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'right',
                                    }}
                                    id={id}
                                    open={openInstaAccount}
                                    anchorEl={anchorEl}
                                    onClose={handleCloseInstaAccount}
                                >
                                    <Box sx={{ padding: "5px", width: "600px" }}>
                                        {isLoadingInstaButton && <Box style={{ marginTop: "50px", border: "1px solid black" }}><CircularProgress style={{ color: "black", }} size={100} /></Box>}
                                        {!isLoadingInstaButton && instaUsernames.map((value, index) => (
                                            <Grid container sx={{ padding: "5px" }}>
                                                <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                                                    <Typography>{value}</Typography>
                                                </Grid>
                                                <Grid item xs={6} sx={{ display: "flex", alignItems: "center" }}>
                                                    <InstagramLogin userData={user} username={value} />
                                                </Grid>
                                                <Divider sx={{ width: "100%", marginTop: "10px" }} />
                                            </Grid>
                                            // <Box key={index} sx={{ display: "flex", alignItems: "center", margin: "10px 5px 10px 5px", gap: "5px" }}>
                                            // <Typography>{value}</Typography>
                                            // <InstagramLogin userData={user} username={value} />
                                            // </Box>
                                        ))}
                                    </Box>
                                </Popover>
                            </Box>
                        </Box>

                        <Box sx={{ width: "40%", marginTop: "20px", display: "flex", justifyContent: "space-between", width: "100%" }}>
                            <TextField
                                sx={{ width: "40%" }}
                                hiddenLabel
                                value={searchCampaign}
                                onChange={handleSearchCampaign}
                                size='small'
                                placeholder='Search Campaigns'
                                InputProps={{
                                    disableUnderline: true,
                                    startAdornment: (
                                        <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                                            <SearchIcon />
                                        </Box>
                                    ),
                                }}
                            />
                            {tabValue == 0 && <Box sx={{ display: "flex", width: "fit-content", justifyContent: "center", alignItems: "center" }}>
                                <Typography>BLI Active Campaigns</Typography>
                                <Checkbox checked={isBliActive} onClick={() => handleBliCampaignFilter()} size='small' />
                            </Box>}
                        </Box>

                        <CustomTabPanel value={tabValue} index={0} >
                            {tempActiveCampaigns.map((value, index) => (
                                <div style={{ padding: "8px" }} key={index}>
                                    <TrackingBar campaignStatus={0} gradientColor="#F8C036" campaignData={value} />
                                </div>
                            ))}
                        </CustomTabPanel>
                        <CustomTabPanel value={tabValue} index={1}>
                            {tempPausedCampaigns.map((value, index) => (
                                <div style={{ padding: "8px" }} key={index}>
                                    <TrackingBar campaignStatus={1} gradientColor="#EFC3FF" campaignData={value} />
                                </div>
                            ))}
                        </CustomTabPanel>
                        <CustomTabPanel value={tabValue} index={2}>
                            {tempDraftCampaigns.map((value, index) => (
                                <div style={{ padding: "8px" }} key={index}>
                                    <TrackingBar campaignStatus={2} gradientColor="#B7E4FD" campaignData={value} />
                                </div>
                            ))}
                        </CustomTabPanel>
                        <CustomTabPanel value={tabValue} index={3}>
                            {tempArchivedCampaigns.map((value, index) => (
                                <div style={{ padding: "8px" }} key={index}>
                                    <TrackingBar campaignStatus={3} gradientColor="#F0F0F0" campaignData={value} />
                                </div>
                            ))}
                        </CustomTabPanel>
                    </Box>}
                <div style={{ display: displayCampaignsNoResults }}>
                    <div style={{ display: "flex", justifyContent: "center", }}>
                        <Box
                            component="img"
                            sx={{
                                height: "490px",
                                width: "370px",
                            }}
                            alt="Campaigns No Results"
                            src={CampaignsNoResults}
                        />
                    </div>
                </div>
            </Grid>
            <Outlet />
        </div >
    )
}

export default TrackingHome